
import store from '@/store';
import { defineComponent } from 'vue';
import { GetUserModel } from '@/interfaces/users/get-user.model';
import ButtonComponent from '@/components/appComponents/Button.vue';
import { UserAcceptedAuthModel } from '@/interfaces/users/user-accepted-auth.model';
import ProfileInfoComponent from '@/components/usersComponents/ProfileInfo.vue';
import AccountChargeBoxComponent from '@/components/usersComponents/AccountChargeBox.vue';
import UserStatementComponent from '@/components/usersComponents/UserStatement.vue';

export default defineComponent({
    name: "UserProfilePage",

    props: ["userId"],

    components: { ButtonComponent, ProfileInfoComponent, AccountChargeBoxComponent, UserStatementComponent },

    data() {
        return {
            selectedBox: "info",
            boxes: [
                {
                    title: "اطلاعات هویتی",
                    value: "info",
                    icon: "mdi-card-account-details-outline"
                },
                {
                    title: "موجودی‌ها",
                    value: "wallets",
                    icon: "mdi-wallet-outline"
                },
                {
                    title: "صورتحساب",
                    value: "statement",
                    icon: "mdi-receipt-text-outline"
                }
            ],
        }
    },

    computed: {
        getUserInfo(): GetUserModel {
            return store.getters["panel/getUserInfo"];
        },

        getUserAcceptedAuth(): UserAcceptedAuthModel {
            return store.getters["panel/getUserAcceptedAuth"];
        },

        getUserFinancialLogs() {
            return store.getters["panel/getUserFinancialLogs"];
        },

        getUserStatement() {
            return store.getters["panel/getUserStatement"];
        },

        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        }
    },

    methods: {
        back(): void {
            this.$emit("back");
        },

        handleBox(box: { title: string, value: string }) {
            this.selectedBox = box.value;
            this.$emit("search", { status: this.selectedBox, query: '' });

            // Load statement data when statement tab is selected
            if (box.value === 'statement') {
                store.dispatch("panel/getUserStatementRequest", {
                    userId: this.userId,
                    page: 1,
                    pageSize: 50
                });
            }
        },

        handleToggleStatusCard(cardData: { userId: string, cardno: number, status: boolean }): void {
            store.dispatch("panel/toggleStatusCardRequest", cardData);
        },

        handleRemoveShetabCard(cardData: { userId: string, cardno: number }): void {
            store.dispatch("panel/removeShetabCardRequest", cardData);
        },

        handleChargeAndDechargeWalletAccount(chargeData: { userId: string, type: string, amount: string, description: string }): void {
            if(chargeData.type === '1') {
                store.dispatch("panel/chargeWalletAccountRequest", chargeData).then(() => {
                    // this.selectedBox = "info";
                    this.back();
                });
            }

            if(chargeData.type === '2') {
                store.dispatch("panel/dechargeWalletAccountRequest", chargeData).then(() => {
                    // this.selectedBox = "info";
                    this.back();
                });
            }
        },

        handleUserCashout(cashoutData: { userId: string, amount: number, perday: number, permin: number }): void {
            store.dispatch("panel/userCashoutSettingRequest", cashoutData);
        },

        handleFindClub(data: { userId: string, mobile: string }): void {
            store.dispatch("panel/findClubRequest", data);
        },

        handleStatementPageChange(page: number): void {
            store.dispatch("panel/getUserStatementRequest", {
                userId: this.userId,
                page: page,
                pageSize: 50
            });
        },

        handleStatementFilterChange(filters: {
            category?: "charge" | "payment" | "withdraw" | "transfer" | "commission" | "settlement" | "crypto" | "all";
            currency?: string;
            minAmount?: string;
            maxAmount?: string;
            status?: "SUCCESS" | "FAILED" | "PENDING" | "CANCELLED";
            from?: string;
            to?: string;
        }): void {
            store.dispatch("panel/getUserStatementRequest", {
                userId: this.userId,
                page: 1, // Reset to first page on filter change
                pageSize: 50,
                ...filters
            });
        },

        handleStatementRefresh(): void {
            store.dispatch("panel/getUserStatementRequest", {
                userId: this.userId,
                page: 1,
                pageSize: 50
            });
        },

        handleStatementExport(): void {
            // TODO: Implement export functionality
            console.log('Export statement data');
        }
    },

    mounted() {
        store.dispatch("panel/getUserInfoRequest", this.userId);
        store.dispatch("panel/getUserAcceptedAuthRequest", this.userId);
        store.dispatch("panel/getUserFinancialLogsRequest", this.userId);
    }
})
